module.exports = __webpack_public_path__ + "static/img/d6a183e.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/sendPoints/pic2.png
// module id = 687
// module chunks = 2